<template>
  <header id="header" class="header">
    <img class="header-logo" :src="logo">
    <img class="header-logo-s" :src="logoS">
    <h1 class="header-title">{{ title }}</h1>
    <!-- 試験画面のときは受験者名を表示しない -->
    <span
      v-if="applicantName && !isEditor"
      class="header-user header-applicant"
    >
      {{ applicantName }}さん
    </span>
    <b-dropdown
      v-if="recruiterName"
      class="header-user"
      :text="recruiterName + 'さん'"
    >
      <b-dropdown-item @click="postLogout">ログアウト</b-dropdown-item>
    </b-dropdown>
  </header>
</template>

<script>
import Logo from '@/main/frontend/assets/logo_header.png'
import LogoS from '@/main/frontend/assets/logo_header_mob.png'

export default {
  data() {
    return {
      logo: Logo,
      logoS: LogoS,
      title: null,
      applicantName: null,
      recruiterName: null,
      isEditor: this.$route.path.split('/')[2] === 'editor', // 試験画面のURLのときtrue
    };
  },
  mounted() {
    // エンドポイントで分岐してタイトル, ユーザー名を取得
    const firstEndpoint = this.$route.path.split('/')[1];
    switch (firstEndpoint) {
      case 'exam':
        this.title = 'マイクロアド新卒採用コーディング試験'
        this.$axios
          .get('/api/applicant/name')
          .then((response) => (this.applicantName = response.data))
        break
      case 'admin':
        this.title = 'マイクロアド新卒採用コーディング試験管理システム'
        this.$axios
          .get('/api/recruiter/name')
          .then((response) => (this.recruiterName = response.data))
        break
    }
  },
  methods: {
    postLogout() {
      this.$axios.post('/admin/logout').then(
        window.location.href = '/admin/login'
      ).catch((error) => {
        // 本番環境(HTTPS)の場合は、失敗と判定される
        // alert('ログアウトに失敗しました\n' + error)
      })
    }
  }
}
</script>

<style scoped>
.header {
  background-color: #333;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 5;
}
.header-logo {
  left: 15px;
  position: absolute;
  top: 10px;
  width: 180px;
}
.header-logo-s {
  display: none;
}
.header-title {
  color: #fff;
  font-size: 20px;
  margin: 0;
  padding: 14px 0;
  text-align: center;
}
.header-user {
  position: absolute;
  right: 15px;
  top: 7px;
}
.header-applicant {
  background-color: #6c757d;
  border-radius: 0.25rem;
  color: #fff;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  padding: .375rem .75rem;
}
@media screen and (max-width: 950px) {
  .header-logo {
    display: none;
  }
  .header-logo-s {
    display: inline-block;
    left: 30px;
    position: absolute;
    top: 9px;
    width: 50px;
  }
  .header-title {
    font-size: 16px;
    padding: 17px 0;
  }
  .header-user {
    top: 14px;
  }
  .header-user >>> .dropdown-toggle,
  .header-user >>> .dropdown-item,
  .header-applicant {
    font-size: 0.8rem;
    line-height: 1.0;
  }
}
</style>
